export const GET_VERSION = Symbol('GET_VERSION');

export function setCuiVersion(val) {
    return {
        type: GET_VERSION,
        payload: val
    }
}
